module.exports = __webpack_public_path__ + "img/logo_3ue.742dfacb.svg";